import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { setDropDownStyle } from '../CommonHelper';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import DateInput2 from '../Common-Components/DateInput2';



const LiveSteamingModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [loading, setLoading] = useState(false);
    const [courses, setCourses] = useState([]);
    const [testSeries, setTestSeries] = useState([]);
    const getInitialState = () => ({
        ModuleType: 'course',
        CourseName: 'Please Select Program Name',
        CourseID: '',
        StartDate: dayjs(), // ✅ Always gets the CURRENT time when called
        Title: ''
    });

    const [formData, setFormData] = useState(getInitialState());
    console.log(formData);

    useImperativeHandle(ref, () => ({
        openModal() {
            setModalBox(true);
            (async () => {//IIFE-> Immediately Invoked Function Expression
                const courseResponse = await axios.get(BACKEND_SERVER_URL + '/getCoursesForTopic');
                const testSeriesResponse = await axios.get(BACKEND_SERVER_URL + '/getTestSeriesForDropDowns');
                setCourses(courseResponse.data.courses?.map((course) => ({ ...course, title: course.courseTitle })));
                setTestSeries(testSeriesResponse.data.testSeries);
            })();
        }
    }));

    const handleSaveLink = () => {
        setLoading(true);
        if (formData.CourseID === '') {
            toast.error("Please select any Course or Test Series");
            setLoading(false);
            return;
        } else if (!formData.StartDate) {
            toast.error("Please select date and time");
            setLoading(false);
            return;
        }
        const payload = {
            ...formData,
            StartDate: dayjs(formData.StartDate).toISOString()
        };
        axios.post(BACKEND_SERVER_URL + `/create-stream`, payload).then((response) => {
            toast.success(response.data.message)
            props.setTopicsLoading(!props.loadTopics);
            setFormData(getInitialState())
            setModalBox(false);

        }).catch(error => {
            console.log(error)
            toast.error(error.response.data.message)
        }).finally(() => {
            setLoading(false);
        })
    }
    useEffect(() => {
        if (!modalBox) {
            setFormData(getInitialState()); // Reset form data when modal is closed            
        }
    }, [modalBox]);
    function setDate(date) {
        setFormData((preData) => ({ ...preData, StartDate: date }));
    }
    return (
        <>

            <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static"
                keyboard={false} >
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel"> Create Live Streaming</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body pt-3">
                        <div className="mb-3 ">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary ">Program Type<span className="required">*</span></label>
                            <Select
                                value={{ value: formData.ModuleType, label: formData.ModuleType.toUpperCase() }}
                                onChange={(selectedOption) => setFormData((preData) => ({ ...preData, ModuleType: selectedOption.value }))}
                                options={['course', 'test-series'/* , 'Interview' */]?.map((item) => ({ value: item, label: item.toUpperCase() }))}
                                styles={setDropDownStyle()}
                            />
                        </div>
                        {
                            formData.ModuleType !== 'Interview' &&
                            <div className="mb-3 ">
                                <label htmlFor="inputAcademicYear" className="form-label text-primary ">Pragram Name<span className="required">*</span></label>
                                <Select
                                    value={{ value: formData.CourseName, label: formData.CourseName }}
                                    onChange={(selectedOption) => setFormData((preData) => ({ ...preData, CourseName: selectedOption.value.title, CourseID: selectedOption.value.courseId }))}
                                    options={(formData.ModuleType == 'course' ? courses : testSeries)?.map((item) => ({ value: item, label: item.title }))}
                                    styles={setDropDownStyle()}
                                />
                            </div>
                        }
                        <div className="mb-3 ">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary ">Date & Time<span className="required">*</span></label>
                            <DateInput2 date={formData.StartDate} setDate={setDate} />
                        </div>
                        <div className="mb-3 ">
                            <label htmlFor="inputAcademicYear" className="form-label text-primary ">Stream Title<span className="required">*</span></label>
                            <input type="text" className="form-control" value={formData.Title}
                                onChange={(e) => setFormData((preData) => ({ ...preData, Title: e.target.value }))}
                            />
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" disabled={loading} className="btn btn-primary btn-xs " onClick={handleSaveLink}>Add</button>
                    </div>
                </div>
            </Modal>

        </>
    )
})
export default LiveSteamingModal;